import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import CreateWarehouse from './create'

import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import IndianaScroller from 'react-indiana-drag-scroll'

const WarehouseToolbar = (props) => {
  const { selected, add, remove,  edit } = props

  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const deleteConfirmation = () => setDeleteDialog(true)
  const confirmDelete = () => remove(selected.id) || setDeleteDialog(false)
  const closeDelete = () => setDeleteDialog(false)

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <Typography
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Almacenes
        <Dialog onClose={closeDelete} open={deleteDialog}>
          <DialogTitle>Eliminar</DialogTitle>
          <Button onClick={confirmDelete}>Ok</Button>
        </Dialog>
      </Typography>
      {selected && 
        <React.Fragment>
          <Tooltip title="Editar">
            <IconButton onClick={() => edit(selected.id)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar">
            <IconButton onClick={deleteConfirmation}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      }
      
      <Tooltip title="Añadir publicidad">
        <IconButton onClick={add}>
          <AddIcon />
        </IconButton>
      </Tooltip>
    </Toolbar>
  )
}

const WarehouseList = () => {
  const app = React.useContext(AppContext)
  const { current } = app
  const { warehouses, remove, detail } = app.warehouses
  const [open, setOpen] = React.useState(false)
  const openD = (s) => {
    setOpen(true)
  }
  return (
    <IndianaScroller>
    <Stack>
      <WarehouseToolbar selected={current} add={openD} edit={openD} remove={remove}/>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell alignt="left">Nombre</TableCell>
              <TableCell alignt="left">Dirección</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {warehouses && warehouses.map((warehouse) => (
              <TableRow
                selected={current.id == warehouse.id}
                onClick={() => current && current.id == warehouse.id?detail(false):detail(warehouse)}
                key={warehouse.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                
                <TableCell align="left">{warehouse.name}</TableCell>
                <TableCell align="left">{`${warehouse.address.street.name} ${warehouse.address.exterior} ${warehouse.address.interior || ''}, ${warehouse.address.postal_code}, ${warehouse.address.street.city.name}, ${warehouse.address.street.city.state.name}, ${warehouse.address.street.city.state.country.name}` }</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CreateWarehouse open={open} model={current} close={() => setOpen(false)}/>
    </Stack>
    </IndianaScroller>
  )
}
export default WarehouseList